import React from "react";
import SbEditable from "storyblok-react";
import RichText from "src/utils/RichText";
import Heading from "src/components/Heading";
import Form from "src/components/Form";

const ContactSplitTwoTone = ({ blok }) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className="relative bg-[#f5f5f5]">
        <div className="absolute inset-0">
          <div className="absolute inset-y-0 left-0 w-1/2 bg-darkgrey" />
        </div>
        <div className="relative max-w-7xl mx-auto lg:grid lg:grid-cols-5">
          <div className="bg-darkgrey md:flex md:flex-wrap md:content-center py-16 px-4 sm:px-6 lg:col-span-2 lg:px-6 xl:pr-16">
            <div className="max-w-lg mx-auto">
              <Heading size="h2" className="text-white mb-2">
                <span className="inline-block text-white mb-2">
                  {blok.title}
                </span>
                <span className="inline-block text-red mb-2 ml-2">
                  {blok.bold_title}
                </span>
              </Heading>
              <span className="mt-3 text-sm font-normal leading-5 text-white border-l-2 border-white pl-2.5 block">
                <RichText>{blok.intro_content}</RichText>
              </span>
              <dl className="mt-12 font-display font-normal text-lg text-white">
                <div>
                  <dt className="sr-only">Postal address</dt>
                  <dd className="leading-5">
                    <RichText>{blok.address}</RichText>
                  </dd>
                </div>
                <div className="mt-6 leading-4">
                  <dt className="sr-only">Phone number</dt>
                  <dd className="flex">
                    <span>T:</span>
                    <span className="ml-1">
                      <a href={`tel:${blok.telephone}`}>
                        <span className="text-red">{blok.telephone}</span>
                      </a>
                    </span>
                  </dd>
                </div>
                <div className="mt-1">
                  <dt className="sr-only">Email</dt>
                  <dd className="flex">
                    <span>E:</span>
                    <span className="ml-1 transition duration-500 hover:text-red">
                      <a
                        href={`mailto:${blok.email}?subject=Liquid Screeding enquiry`}
                      >
                        {blok.email}
                      </a>
                    </span>
                  </dd>
                </div>
                <div className="relative mt-14">
                  <a
                    className="text-white transition duration-300 hover:text-red mr-3"
                    href="https://twitter.com/TLFResearch"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fab fa-twitter fa-lg"></i>
                  </a>
                  <a
                    className="text-white transition duration-300 hover:text-red"
                    href="https://www.linkedin.com/groups?home=&amp;gid=2140154"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fab fa-linkedin-in fa-lg"></i>
                  </a>
                </div>
              </dl>
            </div>
          </div>
          <div className="bg-[#f5f5f5] py-16 px-4 sm:px-6 lg:col-span-3 lg:py-24 lg:px-16 xl:pl-28">
            <div className="max-w-lg mx-auto lg:max-w-none">
              { blok.form && <Form blok={blok.form[0]} /> }
            </div>
          </div>
        </div>
      </div>
    </SbEditable>
  );
};

export default ContactSplitTwoTone;
